import React from 'react';

const Banner: React.FC = () => {
  return (
    <div className="bg-dark text-white py-2.5 px-4 text-center sticky top-0 z-[110] border-b border-white/10 shadow-lg">
      <p className="text-[10px] md:text-xs font-black uppercase tracking-[0.2em]">
        🚀 PROGRAMA EARLY ADOPTER 2026 — <span className="text-fhir">ONBOARDING EN CURSO</span>
      </p>
    </div>
  );
};

export default Banner;
